import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: '1. Scope',
    body: [
      'This Privacy Policy explains how TalasTradingCo handles information in connection with the TalasTradingCo website, software, dashboards, automations, and related services used for authorized trade-following through a supported broker connection.',
    ],
  },
  {
    title: '2. Information TalasTradingCo is designed to collect',
    body: [
      'TalasTradingCo is designed to collect only the limited information necessary to connect a supported brokerage account through an OAuth or similar delegated-authorization flow and operate the service you select.',
      'This may include the broker-issued authorization token or similar credential, connection status, granted permission scopes, minimal integration identifiers needed to maintain the connection, and your selected follow mode, such as the Talas stock bot or Talas mirror bot.',
    ],
  },
  {
    title: '3. Information TalasTradingCo is not designed to request directly',
    body: [
      'TalasTradingCo is not designed to request your brokerage username or password directly as part of the intended OAuth-style connection workflow.',
      'TalasTradingCo is also not designed as a general advertising, profile-building, or broad consumer-tracking product.',
    ],
  },
  {
    title: '4. How we use the limited information we receive',
    body: [
      'We use the limited connection information described above to establish and maintain your authorized broker connection, determine which Talas follow mode you selected, and operate the related trade-following workflow you authorized.',
      'We may also use that limited information to maintain security, troubleshoot connection problems, prevent misuse of the Service, and comply with legal obligations.',
    ],
  },
  {
    title: '5. Storage and security',
    body: [
      'Authorization tokens and similar credentials are encrypted at rest using Fernet symmetric encryption with rotating keys. Full credentials are never displayed back to users or administrators after initial entry.',
      'Access to connection metadata is limited to operators with a legitimate need to maintain, troubleshoot, or audit the Service.',
    ],
  },
  {
    title: '6. Retention',
    body: [
      'Connection information is retained for the duration of the active broker connection and for a limited period thereafter to support audit, dispute resolution, and legal obligations. You may request disconnection of your broker at any time from your dashboard.',
    ],
  },
  {
    title: '7. Your choices',
    body: [
      'You may disconnect your broker at any time. You may request deletion of connection metadata where not required to be retained for legal or audit purposes by contacting tspeichingeriii@gmail.com.',
    ],
  },
  {
    title: '8. Children',
    body: ['The Service is not directed to individuals under the age of majority in their jurisdiction. Do not use the Service if you do not meet this requirement.'],
  },
  {
    title: '9. Changes',
    body: ['We may update this Privacy Policy from time to time. The updated version becomes effective when posted through the Service. Continued use after an update means you accept the revised policy.'],
  },
  {
    title: '10. Contact',
    body: ['Questions regarding this Privacy Policy may be sent to tspeichingeriii@gmail.com.'],
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:gold-text">
          <ArrowLeft size={14} /> Back to home
        </Link>
        <div className="mt-8">
          <p className="text-[10px] tracking-[0.25em] font-mono gold-text">LEGAL</p>
          <h1 className="font-display mt-4 text-4xl md:text-5xl font-bold text-white">Privacy Policy</h1>
          <p className="mt-4 text-zinc-400 max-w-2xl">
            Limited-data policy for authorized OAuth-based broker connections used to follow Talas trading bots.
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-md">
            <div className="border border-white/10 rounded-sm p-4">
              <p className="text-[10px] tracking-widest font-mono text-zinc-500">EFFECTIVE DATE</p>
              <p className="text-sm text-white mt-1">March 11, 2026</p>
            </div>
            <div className="border border-white/10 rounded-sm p-4">
              <p className="text-[10px] tracking-widest font-mono text-zinc-500">LAST UPDATED</p>
              <p className="text-sm text-white mt-1">March 11, 2026</p>
            </div>
          </div>
        </div>

        <div className="mt-10 border-l-2 gold-border pl-5 py-4 bg-white/[0.02]">
          <p className="text-[10px] tracking-widest font-mono gold-text">DATA-MINIMIZATION STATEMENT</p>
          <p className="mt-2 text-sm text-zinc-300 leading-relaxed">
            TalasTradingCo is designed to limit collection to the information needed to establish and operate an authorized broker connection for the follow-trading service you choose.
          </p>
        </div>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-xl font-semibold gold-text">{s.title}</h2>
              <div className="mt-3 space-y-3">
                {s.body.map((p) => (
                  <p key={`${s.title}-${p.slice(0, 40)}`} className="text-sm text-zinc-300 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <p className="mt-16 text-center text-xs text-zinc-500">TalasTradingCo · Privacy Policy</p>
      </main>
      <Footer />
    </div>
  );
}
